var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediaPdfIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18.047,
    viewBox: "0 0 18 18.047",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}.c{fill:#0d0d0d;font-size:4px;font-family:Arial-BoldMT, Arial;font-weight:700;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.035)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-288 -104)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18,
    transform: "translate(288 104)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(286.772 102.715)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.446,2H5.655A1.655,1.655,0,0,0,4,3.655V16.892a1.655,1.655,0,0,0,1.655,1.655h9.928a1.655,1.655,0,0,0,1.655-1.655v-9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13,2V7.791h5.791",
    transform: "translate(-1.554)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "c",
    transform: "translate(293 116)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PDF"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaPdfIcon);
export default __webpack_public_path__ + "static/media/media-pdf-icon.ca842c769c9ec822aaa65f85d267a3b0.svg";
export { ForwardRef as ReactComponent };